module.exports = __webpack_public_path__ + "assets/shuxie.36dc2ad5.svg";